var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs';
import moment from 'moment';
moment.locale('de');
import { TranslateService } from '@ngx-translate/core';
export class ShowAttachedReservations {
    constructor(activeModal, translate) {
        this.activeModal = activeModal;
        this.translate = translate;
        this.passEntry = new EventEmitter();
        this.ngUnsubscribe = new Subject();
        this.translate.onLangChange.subscribe((event) => { });
    }
    ngOnInit() {
        const _a = this.selectedReservation, { attachedReservations } = _a, mainReservation = __rest(_a, ["attachedReservations"]);
        this.selectedReservation.attachedReservationsCustom = [
            mainReservation,
            ...this.selectedReservation.attachedReservations
        ];
        if (this.selectedReservation &&
            this.selectedReservation.attachedReservationsCustom &&
            this.selectedReservation.attachedReservationsCustom.length &&
            this.selectedReservation.attachedReservationsCustom.some((res) => res.parentId)) {
            this.selectedReservation = this.transformHotelReservation(this.selectedReservation);
        }
        else {
            this.selectedReservation = this.transformPackageData(this.selectedReservation);
        }
    }
    transformPackageData(data) {
        const cateringPackage = data && data.reservationInfo.Packages && data.reservationInfo.Packages.includes('Package Code')
            ? data.reservationInfo.Packages.split('Package Code:')[0].trim()
            : '';
        if (cateringPackage) {
            data.cateringPackage = cateringPackage;
        }
        return Object.assign({}, data, { attachedReservationsCustom: (data.attachedReservationsCustom || []).map((item) => (Object.assign({}, item, { reservationInfo: {
                    RatePlanCode: item && item.reservationInfo && item.reservationInfo.RatePlanCode ? item.reservationInfo.RatePlanCode : '',
                    Packages: item &&
                        item.reservationInfo &&
                        item.reservationInfo.Packages &&
                        item.reservationInfo.Packages.includes('Package Code')
                        ? item.reservationInfo.Packages.split('Package Code:')[1].trim()
                        : item.reservationInfo.Packages || ''
                } }))) });
    }
    transformHotelReservation(data) {
        if (!(data.guestInfo && data.guestInfo.name)) {
            data.guestInfo = {
                name: data.guestData ? data.guestData.name : null,
                firstName: data.guestData ? data.guestData.firstName : null
            };
        }
        const cateringPackage = data && data.packages && data.packages.includes('Package Code')
            ? data.packages.split('Package Code:')[0].trim()
            : '';
        if (cateringPackage) {
            data.cateringPackage = cateringPackage;
        }
        return Object.assign({}, data, { attachedReservationsCustom: (data.attachedReservationsCustom || [])
                .sort((a, b) => {
                const roomA = a.roomNo;
                const roomB = b.roomNo;
                // both have roomNo → sort by roomNo
                if (roomA != null && roomB != null) {
                    if (roomA !== roomB) {
                        return roomA - roomB; // numeric
                    }
                    return a.id - b.id; // fallback
                }
                // only one has roomNo → prioritize it
                if (roomA != null)
                    return -1;
                if (roomB != null)
                    return 1;
                // neither has roomNo → sort by id
                return a.id - b.id;
            })
                .map((item) => ({
                reservationNo: item.bookingNumber,
                arrivalDate: item.arrivalDate ? item.arrivalDate.split(' ')[0] : null,
                departureDate: item.departureDate ? item.departureDate.split(' ')[0] : null,
                guestCount: item.guestCount,
                roomNo: item.roomNo,
                companyName: item.guestData && item.guestData.company ? item.guestData.company : null,
                attachedCode: item.attachedCode,
                childCount: item.childCount || 0,
                guestInfo: item.guestInfo
                    ? item.guestInfo
                    : {
                        name: item.guestData ? item.guestData.name : null,
                        firstName: item.guestData ? item.guestData.firstName : null,
                        email: item.guestData ? item.guestData.email : null,
                        phone: item.guestData ? item.guestData.phone : null,
                        guestNotes: item.guestData && item.guestData.notes ? item.guestData.notes : ''
                    },
                reservationInfo: {
                    RatePlanCode: item.groupTags || '',
                    Packages: item && item.packages && item.packages.includes('Package Code')
                        ? item.packages.split('Package Code:')[1].trim()
                        : item.packages || ''
                }
            })) });
    }
    fetchColor(board) {
        const meal = this.mealOptions.find((option) => option.value === board);
        return meal ? meal.color : 'gray';
    }
    ngOnDestroy() {
        this.passEntry.emit();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
